import {computeIsConfigTable} from 'notebook/tables/store/logic/TableContextLogic';
import {createTableModelSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';

export interface TableContextModel {
  isConfigTable: boolean;
}

export function createTableContextSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableContextModel {
  return createTableModelSelector(
    [
      (store) => volatilePropsSelector(store).table,
      (store) => store.editorContext.isConfig,
      (store) => store.stableProps.fileIsConfig,
    ],
    (table, editorContextIsConfig, fileIsConfigProp) => ({
      isConfigTable: computeIsConfigTable(table, editorContextIsConfig, fileIsConfigProp),
    })
  );
}
